/* eslint-disable no-param-reassign */
import { createSlice, createAction } from '@reduxjs/toolkit';
import { isTouristsValid } from 'src/components/Tourists/utils';
import { touristsSelector } from 'src/store/tourists/selectors';

const initialState = {
  inProgress: false,
  validations: {},
};
const name = 'touristsCheckoutValidation';

// Валидации паспортов туристов
// reducer + actions
const touristCheckoutValidation = createSlice({
  name,
  initialState,
  reducers: {
    clearValidations(state) {
      state.validations = initialState.validations;
    },
    addValidation(state, action) {
      const { passportNumber, validation } = action.payload;
      state.validations[passportNumber] = validation;
    },
    setValidationInProgress(state, action) {
      state.inProgress = action.payload;
    },
  },
});

// selectors
export const getValidations = (state) => state[name].validations;
export const getInProgress = (state) => state[name].inProgress;
export const touristsValidationSelector = (state) => {
  const validations = getValidations(state);
  const tourists = touristsSelector(state);

  return isTouristsValid(tourists, validations);
};

export const { clearValidations, addValidation, setValidationInProgress } =
  touristCheckoutValidation.actions;

export const validateAll = createAction(`${name}/validateAll`);

export default touristCheckoutValidation.reducer;
